import { useMoveToGoods } from './moveToGoods';
import { useMoveToGoodsList } from './moveToGoodsList';
import { useMoveToRecentlyViewedGoods } from './moveToRecentlyViewedGoods';
import { useMoveToRankingGoods } from './moveToRankingGoods';

export const useGoodsNavigator = () => {
  const moveToGoods = useMoveToGoods();
  const moveToGoodsList = useMoveToGoodsList();
  const moveToRecentlyViewedGoods = useMoveToRecentlyViewedGoods();
  const moveToRankingGoods = useMoveToRankingGoods();

  return {
    moveToGoods,
    moveToGoodsList,
    moveToRecentlyViewedGoods,
    moveToRankingGoods,
  };
};